import { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { Form } from 'antd'

import { AppContext } from '../../context/AppContext'

import PageWrap from '../../components/layout/PageWrap'
import FormWrap from '../../components/forms/FormWrap'
import FormBlock from '../../components/forms/FormBlock'
import Loader from '../../components/Loader'
import Error from '../../components/Error'

import { TypeDescription } from '../../constants/forms/ProductTypes'
import {
    EditProductType,
    getSingleProductType,
} from '../../network/ProductTypes'

const ProductTypeDetails = () => {
    const { token } = useContext(AppContext)
    const [form] = Form.useForm()
    let { typeId } = useParams()

    const typeDetails = useQuery(
        [
            'getSingleProductType',
            {
                typeId: typeId,
                token: token.token,
            },
        ],
        getSingleProductType,
        {
            refetchOnWindowFocus: false,
        }
    )

    return (
        <PageWrap
            goBack
            isLoading={typeDetails.isLoading}
            title={typeDetails.data?.name}
        >
            {typeDetails.isError ? (
                <Error retry={() => typeDetails.refetch()} />
            ) : typeDetails.isLoading ? (
                <Loader />
            ) : (
                <FormWrap
                    title="edit_product_type"
                    request={EditProductType}
                    onSuccess="/product-types"
                    onCancel="/product-types"
                    id={typeId}
                    data={typeDetails.data}
                    invalidate={['getProductTypesList', 'getSingleProductType']}
                >
                    <div className="SectionHorizontalWrap">
                        <FormBlock form={form} formTemplate={TypeDescription} />
                    </div>
                </FormWrap>
            )}
        </PageWrap>
    )
}

export default ProductTypeDetails
